<template>
  <div id="app">
    <router-view />
    <!-- <datav /> -->
  </div>
</template>

<script>
import datav from "./components/datav/index.vue";
import autofit from "autofit.js";
// import { communityList } from "../../mock";

export default {
  name: "app",
  components: {
    datav,
  },
  data() {
    return {};
  },
  mounted() {
    // setTimeout(() => {
    //   this.$EditionEmptyDialog({
    //     show: true,
    //   });
    // }, 2000);
    autofit.init({
      // designHeight: 1080,
      designHeight: 1800,
      // designHeight: 929,
      designWidth: 1920,
      renderDom: "#app",
      resize: true,
    });
  },
};
</script>

<style lang="less">
@import "./assets/common-color.less";
img {
  display: inline-block !important;
}
::-webkit-scrollbar {
  display: none;
}
::v-deep {
  .el-loading-spinner {
    display: flex;
    justify-content: center;
  }
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  color: #abd1e7;
  // background-image: url("./img/bg1.png");
  // background-image: url("./components/datav/img/bg.png");
  // background-size: 100% 100%;
  background: linear-gradient(95deg, #abd1e7, #abd1e7);
  box-shadow: -4px -3px 4px 0px rgba(4, 54, 151, 0.67);
}
</style>
